import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleMsg = (e) => {
      if (e.data && e.data.type === "NAVIGATE" && typeof e.data.path === "string") {
        navigate(e.data.path);
      }
    };
    window.addEventListener("message", handleMsg);
    return () => window.removeEventListener("message", handleMsg);
  }, [navigate]);

  return (
    <div className="fixed inset-0 w-screen h-screen overflow-hidden bg-[#09090e] z-50">
      <iframe
        src="/landing.html"
        title="KEP PhysicsVerse"
        className="w-full h-full border-0 block"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}
